import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, getResetByTag, utilityStyles, rem } from './../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("border-top:solid ", rem(1), " ", colors.coolGray_500, ";height:0;width:100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var offsetStyles = function offsetStyles(_ref) {
  var isOffset = _ref.isOffset;
  if (isOffset) {
    return /*#__PURE__*/css("margin-left:", rem(16), ";width:calc(100% - ", rem(16), ");" + (process.env.NODE_ENV === "production" ? "" : ";label:offsetStyles;"));
  }
};
var indentedStyles = function indentedStyles(_ref2) {
  var isIndented = _ref2.isIndented;
  if (isIndented) {
    return /*#__PURE__*/css("margin:", rem(0, 16, 0, 16), ";width:auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:indentedStyles;"));
  }
};
var thicknessStyles = function thicknessStyles(_ref3) {
  var thickness = _ref3.thickness;
  switch (thickness) {
    case 'default':
      return /*#__PURE__*/css("border-top-width:", rem(1), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:thicknessStyles;"));
    case 'thick':
      return /*#__PURE__*/css("border-top-width:", rem(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:thicknessStyles;"));
    case 'thicker':
      return /*#__PURE__*/css("border-top-width:", rem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:thicknessStyles;"));
    case 'thickest':
      return /*#__PURE__*/css("border-top-width:", rem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:thicknessStyles;"));
  }
};
var inverseStyles = function inverseStyles(_ref4) {
  var isInverse = _ref4.isInverse;
  return /*#__PURE__*/css(isInverse && "border-top-color: ".concat(colors.white, ";"), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:inverseStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledDivider = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1xjd6qv0"
} : {
  target: "e1xjd6qv0",
  label: "StyledDivider"
})(resetStyles, defaultStyles, offsetStyles, indentedStyles, thicknessStyles, inverseStyles, utilityStyles);
export default StyledDivider;